import React, { useEffect, useState } from 'react';
import { SaveAs } from '@mui/icons-material';
import { Button } from '@mui/material';
import { jsPDF as JSPDF } from 'jspdf';
import PropTypes from 'prop-types';

import SERVER_API_URL from '../../config';
import axiosInstance from '../../api';
import amharicFont from '../../utils/nyala.ttf';
import { ethDate } from '../../utils/ethDate';

const DownloadPDFButton = ({ user, exporter }) => {
  const [avatar, setAvatar] = useState();
  const [confessor, setConfessor] = useState();

  useEffect(() => {
    const getAvatar = async () => {
      try {
        const response = await axiosInstance.get(`${SERVER_API_URL}/avatar/getAvatarById/${user.id}`, {
          responseType: 'blob',
        });
        if (response.status === 200) {
          const url = URL.createObjectURL(response.data);
          setAvatar(url);
        }
      } catch (e) {
        setAvatar(null);
      }
    };

    const getConfessor = async () => {
      try {
        const response = await axiosInstance.post(`${SERVER_API_URL}/user/findOneById/${user?.id}`)
        if (response.status === 200) {
          setConfessor(response.data);
        }
      } catch (e) {
        // console.log(e)
      }
    };
    getAvatar();
    getConfessor();
  }, [user]);

  const generatePDF = () => {
    const pdf = new JSPDF();

    // Load the font
    pdf.addFileToVFS(amharicFont);
    pdf.addFont(amharicFont, 'AmharicFont', 'normal');

    // Set the font for the text
    pdf.setFont('AmharicFont');

    const initialX = 30;
    const initialY = 15;
    const xAttribute = 40;
    const xValue = 58;
    let y = 32;
    const increment = 8;

    // Set header
    pdf.setFontSize(14);
    pdf.addImage("/assets/logo/eotc-logo.png", 'PNG', 8, 3, 10, 10);
    pdf.text(initialX, initialY + 5, 'የሰሜን ሸዋ ሃገረ-ስብከት የመረጃ አስተዳደር ስርዓት');
    const currentDate = ethDate(new Date());
    pdf.setFontSize(12);
    pdf.text(currentDate, pdf.internal.pageSize.getWidth() - 40, initialY + 5);

    // (x1, y1, x2, y2)
    pdf.line(initialX - 5, initialY + increment + 2, 200, initialY + increment + 2);

    // (image, format, x, y, width, height)
    if (avatar) {
      pdf.addImage(avatar, 'PNG', 136, initialY + 15, 40, 40);
    } else {
      pdf.addImage('/assets/icon/empty_user_profile.png', 'PNG', 136, initialY + 15, 40, 40);
    }

    pdf.text('ሙሉ ስም፡ ', xAttribute - 1, y);
    pdf.text(`${user && user.firstName} ${user && user.lastName}`, xValue, y);

    y += increment;
    pdf.text('የክርስትና ስም: ', xAttribute - 6, y);
    pdf.text(user && user.christianName, xValue, y);

    y += increment;
    pdf.text('አውራጃ: ', xAttribute + 2, y);
    pdf.text(user && user.church.district.name, xValue, y);

    y += increment;
    pdf.text('አጥቢያ: ', xAttribute + 2, y);
    pdf.text(user && user.church.name, xValue, y);

    if (user && user.email) {
      y += increment;
      pdf.text('ኢሜል: ', xAttribute + 2, y);
      pdf.text(user && user.email, xValue, y);
    }

    y += increment;
    pdf.text('ስልክ: ', xAttribute + 5, y);
    pdf.text(user && user.phone, xValue, y);

    y += increment;
    pdf.text('የትምህርት ደረጃ: ', xAttribute - 9, y);
    pdf.text(user && user.educationLevel, xValue, y);

    y += increment;
    pdf.text('የጋብቻ ሁኔታ: ', xAttribute - 6, y);
    pdf.text(user && user.marriageStatus, xValue, y);

    y += increment;
    pdf.text('የትውልድ ዘመን: ', xAttribute - 8, y);
    pdf.text(ethDate(user && user.birthDate), xValue, y);

    y += increment;
    pdf.text('የተመዘገበት: ', xAttribute - 2, y);
    pdf.text(ethDate(user && user.createdAt), xValue, y);

    y += increment;
    y += increment;
    const xConfessor = 50;
    pdf.text('የንስሃ አባት መረጃ ', xAttribute + 30, y);

    // pdf.line(initialX - xConfessor, initialY + increment + 2, 100, initialY + increment + 2);
    
    y += increment;
    pdf.text(' ሙሉ ስም: ', xAttribute + xConfessor, y);
    pdf.text(confessor && confessor.fullName, xValue + xConfessor, y);

    y += increment;
    pdf.text('ምድብ (ክህነት): ', xAttribute + xConfessor - 8, y);
    pdf.text(confessor && confessor.category.name, xValue + xConfessor, y);

    y += increment;
    pdf.text('ስልክ ቁጥር: ', xAttribute + xConfessor , y);
    pdf.text(confessor && confessor.phone, xValue + xConfessor, y);

    y += increment;
    pdf.text('ሚና: ', xAttribute + xConfessor + 8, y);
    pdf.text(confessor && confessor.role.name, xValue + xConfessor, y);

    // Set footer
    const totalPages = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i += 1) {
      pdf.setTextColor('gray');

      pdf.setPage(i);
      pdf.setFontSize(12);
      pdf.text(
        `ገጽ ${i} ክ ${totalPages}`,
        pdf.internal.pageSize.getWidth() - 40,
        pdf.internal.pageSize.getHeight() - 10
      );

      pdf.text(
        `አዘጋጅ፡ ${exporter && exporter.firstName} ${exporter && exporter.lastName} (${exporter && exporter.role.name})`,
        initialX,
        pdf.internal.pageSize.getHeight() - 10
      );
    }
    // Save the PDF
    pdf.save(`${user && user.firstName} ${user && user.lastName}.pdf`);
  };

  const handleClick = () => {
    generatePDF();
  };

  return (
    <Button onClick={handleClick}>
      <SaveAs /> መሸኛ አውርድ
    </Button>
  );
};

export default DownloadPDFButton;

DownloadPDFButton.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    christianName: PropTypes.string,
    educationLevel: PropTypes.string,
    marriageStatus: PropTypes.string,
    birthDate: PropTypes.string,
    church: PropTypes.shape({
      name: PropTypes.string.isRequired,
      district: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    email: PropTypes.string,
    phone: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
  exporter: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    role: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};
